import { rgba, tint, shade } from 'polished'
// import { Theme } from 'styled-system'

export const palette = {
  blue: '#017FFF',
  cyan: '#42DDE7',
  red: '#EF5F5F',
  yellow: '#F4C5C4',
  green: '#32CD32',
  skyblue: '#3D9DF8',
  lakeblue: '#42DDE7',
  grayblue: '#3F4D68',
  black: '#0D0F33',
  white: '#FFFFFF'
}

export const black = {
  '100': palette.black,
  '85': rgba(palette.black, 0.85),
  '65': rgba(palette.black, 0.65),
  '45': rgba(palette.black, 0.45),
  '25': rgba(palette.black, 0.25),
  '15': rgba(palette.black, 0.15),
  '08': rgba(palette.black, 0.08),
  '04': rgba(palette.black, 0.04),
  solid: [
    tint(0.1, palette.black),
    tint(0.2, palette.black),
    tint(0.3, palette.black),
    tint(0.4, palette.black)
  ]
}

export const white = {
  '100': palette.white,
  '85': rgba(palette.white, 0.85),
  '65': rgba(palette.white, 0.65),
  '45': rgba(palette.white, 0.45),
  '25': rgba(palette.white, 0.25),
  '15': rgba(palette.white, 0.15),
  '08': rgba(palette.white, 0.08),
  '04': rgba(palette.white, 0.04),
  solid: [
    shade(0.03, palette.white),
    shade(0.15, palette.white),
    shade(0.25, palette.white),
    shade(0.45, palette.white)
  ]
}

export const theme = {
  breakpoints: ['40em', '52em', '64em'],
  space: [0, 4, 8, 16, 32, 64, 128, 256],
  fonts: {
    body: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif`,
    heading: 'inherit',
    monospace: 'Menlo, monospace'
  },
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 96],
  fontWeights: {
    body: 400,
    heading: 700,
    bold: 'bold',
    bolder: 'bolder'
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125
  },
  colors: {
    primary: palette.blue,
    secondary: palette.cyan,
    background: {
      base: white[100],
      lightgray: white.solid[0],
      gray: white.solid[1],
    },
    backdrop: {
      lightgray: black['04'],
      gray: black['08'],
      darkgray: black[15],
      deepgray: black[45]
    },
    text: {
      body: black[85],
      body2: black[65],
      caption: black[45],
      disabled: black[25],
      hint: black[15],
      'body-white': white[100],
      'body2-white': white[65],
      'caption-white': white[45],
      'disabled-white': white[25],
      'hint-white': white[15],
    }
  },
  shadows: {
    card: `0 4px 8px ${black['04']}`,
    deepcard: `0 4px 4px ${black['15']}`
  },
  radii: [2, 4, 8, 16, 32],
  borders: {
    primary: `1px solid ${rgba(palette.blue, .4)}`,
    secondary: `1px solid ${rgba(palette.cyan, .4)}`,
    avatar: `1px solid white`,
    'divider': `1px solid ${black['08']}`,
  }
}
